<template>
    <div v-loading="loading">
        <div class="block">
            页头文案配置：
            <input-set-value
                    width="750px"
                    placeholder="请输入"
                    :defaultValue="listPaymentPage.header"
                    @my-submit="updateUrl('payment_page_header',$event)"/>
        </div>
        <div class="block">
            页尾文案配置：
            <input-set-value
                    width="750px"
                    placeholder="请输入"
                    :defaultValue="listPaymentPage.footer"
                    @my-submit="updateUrl('payment_page_footer',$event)"/>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import inputSetValue from 'components/inputSetValue'

    export default {
        components: {
            inputSetValue,
        },
        data() {
            return {
                loading: false
            }
        },
        computed: {
            ...mapState('functionSwitchConfig', ['listPaymentPage'])
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('functionSwitchConfig', ['getListPaymentPage', 'updatePaymentPage']),
            getList() {
                this.loading = true;
                this.getListPaymentPage().then(() => {
                    this.loading = false
                })
            },
            updateUrl(code, {value, cb}) {
                /*let total = 0,
                    i, len;
                for (i = 0, len = value.length; i < len; i++) {
                    let charCode = value.charCodeAt(i);
                    if (charCode > 127 || charCode === 94) {
                        total += 2;
                    } else {
                        total++;
                    }
                }
                if (code === 'payment_page_header') {
                    if (total > 40) {
                        this.$message.error('您输入的字数，超过限制，请重新输入');
                        return
                    }
                } else {
                    if (total > 100) {
                        this.$message.error('您输入的字数，超过限制，请重新输入');
                        return
                    }
                }*/
                this.updatePaymentPage({
                    code,
                    value
                }).then(() => {
                    this.$message.success('修改成功');
                    cb();
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .block {
        height: 50px;
        line-height: 50px;
        font-weight: bold;
    }
</style>